module.exports = __webpack_public_path__ + "static/subscription-a301a8fe978f0c5a01ea78162c8dafc0.png";